import "./FeatureGrid.css";

interface Feature {
  title: string;
  description: string;
  iconPath: string;
}

const FEATURES: Feature[] = [
  {
    title: "Organizations & branches",
    description:
      "Run multiple branches under one organization with shared settings and clear separation between locations.",
    iconPath:
      "M3 21h18M5 21V7l7-4 7 4v14M9 21v-4h6v4M9 10h.01M15 10h.01M9 14h.01M15 14h.01",
  },
  {
    title: "Team roles & access",
    description:
      "Owners, admins, managers, receptionists, and staff each get exactly the access they need — nothing more.",
    iconPath:
      "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm13 10v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75",
  },
  {
    title: "Clients & services",
    description:
      "Keep client records and your service catalog organized, searchable, and always up to date.",
    iconPath:
      "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
  },
  {
    title: "Appointments & online booking",
    description:
      "Schedule in-house and accept bookings directly from your organization's public site.",
    iconPath:
      "M8 2v4M16 2v4M3 10h18M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Zm4 8 2 2 4-4",
  },
  {
    title: "Follow-ups & messaging",
    description:
      "Stay in touch after every visit with follow-ups and client messaging, sized to your plan.",
    iconPath:
      "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10ZM8 9h8M8 12h5",
  },
  {
    title: "Website content tools & inquiries",
    description:
      "Publish media, stats, and testimonials — and capture contact inquiries from your public site.",
    iconPath:
      "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20ZM2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10Z",
  },
];

const FeatureGrid = () => (
  <section className="features">
    <div className="features__inner">
      <header className="features__header">
        <p className="features__eyebrow">What Carely IT covers</p>
        <h2 className="features__title">
          Everything daily operations need, in one place
        </h2>
        <p className="features__lead">
          No stitched-together tools. Carely IT handles the core of your
          organization's day — from the front desk to follow-up.
        </p>
      </header>

      <ul className="features__grid">
        {FEATURES.map((feature) => (
          <li key={feature.title} className="feature-card">
            <span className="feature-card__icon" aria-hidden="true">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d={feature.iconPath} />
              </svg>
            </span>
            <h3 className="feature-card__title">{feature.title}</h3>
            <p className="feature-card__description">{feature.description}</p>
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export default FeatureGrid;
